/** Outreach comms API (email v1). Sends happen AS the signed-in user (Graph OBO). */
import axios from 'axios';
import type { HeadersGetter } from './customers';

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:7071/api';

export interface CommTemplate {
  template_id: string;
  scope: 'company' | 'store';
  store_id: string | null;
  name: string;
  subject: string;
  body_html: string;
  attachments: { attachment_id: string; file_name: string; content_type: string; size: number }[];
}

export interface Attachment {
  fileName: string;
  contentType: string;
  contentBase64: string;
}

export interface SendResult {
  sent: { customer_id: string; name: string }[];
  skipped: { customer_id: string; name: string; reason: 'no_email' | 'do_not_contact' | 'contacted_recently' | 'not_found' }[];
  failed: { customer_id: string; name: string; error: string }[];
}

export async function listTemplates(getHeaders: HeadersGetter): Promise<CommTemplate[]> {
  const headers = await getHeaders();
  const res = await axios.get<{ templates: CommTemplate[] }>(`${API_BASE}/comms/templates`, { headers });
  return res.data.templates;
}

export async function saveTemplate(
  getHeaders: HeadersGetter,
  input: { name: string; subject: string; bodyHtml: string; scope: 'company' | 'store'; attachments?: Attachment[] }
): Promise<CommTemplate[]> {
  const headers = await getHeaders();
  const res = await axios.post<{ templates: CommTemplate[] }>(`${API_BASE}/comms/templates`, input, { headers });
  return res.data.templates;
}

export async function deleteTemplate(getHeaders: HeadersGetter, id: string): Promise<CommTemplate[]> {
  const headers = await getHeaders();
  const res = await axios.delete<{ templates: CommTemplate[] }>(`${API_BASE}/comms/templates/${id}`, { headers });
  return res.data.templates;
}

/** Clone a store template into the Company group (attachments included). HO only. */
export async function promoteTemplate(getHeaders: HeadersGetter, id: string): Promise<CommTemplate[]> {
  const headers = await getHeaders();
  const res = await axios.post<{ templates: CommTemplate[] }>(`${API_BASE}/comms/templates/${id}`, {}, { headers });
  return res.data.templates;
}

export async function sendEmail(
  getHeaders: HeadersGetter,
  input: { customerIds: string[]; subject: string; bodyHtml: string; templateId?: string; attachments?: Attachment[] }
): Promise<SendResult> {
  const headers = await getHeaders();
  const res = await axios.post<SendResult>(`${API_BASE}/comms/email`, input, { headers });
  return res.data;
}
